import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

import ConfirmDialog from './ConfirmDialog';


const useStyles = makeStyles(theme => ({
    root: {
        cursor: 'pointer',
        textAlign: 'center',
        width: 320,
        margin: 5,
        padding: theme.spacing(2),
        '& > .MuiAvatar-root': {
            width: 120,
            height: 120,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    addPhotoText: {
        marginTop: 4,
        marginBottom: -4,
        height: 0,
        '& button': {
            fontWeight: 400,
        }
    },
    input: {
        display: 'none'
    },
    uploading: {
        opacity: 0.6,
    },
    replaceButton: {
        marginLeft: 18
    },
    deleteIcon: {
        '&:hover': {
            color: theme.palette.secondary.main
        }
    }
}));

const UserAvatar = (props) => {
    const {
        user,
        setUser,
    } = props;

    const classes = useStyles();

    const avatar = user.profile_picture_path;
    const initials = `${user.first_name.toUpperCase()[0]}${user.last_name.toUpperCase()[0]}`;

    const [hover, setHover] = React.useState(false);

    const [isUploading, setIsUploading] = React.useState(false);

    const toggleHover = () => {
        setHover(!hover);
    }

    const handleOnClick = () => {
        ref.current.click();
    }

    const handleUpload = (event) => {
        if (!event.target.value){
            return;
        }
        const fileSize = event.target.files[0].size / 1024 / 1024;
        if (fileSize > 1.5) {
            alert(`Please try a file smaller than 1.5 MB. Actual size: ${fileSize.toFixed(2)} MB`);
            return;
        }
        const formData = new FormData();
        formData.append('_token', window._token);
        formData.append('picture', event.target.files[0]);
        setIsUploading(true);
        new Promise((resolve, reject) => {
            let url = `/api/admin/users/${user.id}/profile-picture`;
            fetch(url, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setUser(result);
                    setIsUploading(false);
                })
                .catch(reason => {
                    setIsUploading(false);
                    alert('An error prevented saving. Please try a different image (JPG, PNG formats only)');
                })
        });
    }

    const deletePicture = () => {
        const data = {
            _token: window._token
        }
        new Promise((resolve, reject) => {
            let url = `/api/admin/users/${user.id}/profile-picture`;
            fetch(url, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setUser(result);
                })
                .catch(reason => {
                    alert('An error prevented deleting the picture. Please refresh the page and try again.');
                })
        });
    };

    const [open, setDialogOpen] = React.useState(false);
    const handleClose = action => () => {
        if (action == 'agree') {
            deletePicture();
        }
        setDialogOpen(false);
    };

    const handleDelete = (event) => {
        setDialogOpen(true);
    }

    const ref = React.createRef();

    const viewImage = () => {
        if (!user.profile_picture_path) return;
        window.open(
            user.profile_picture_path,
            '_blank'
        );
    }

    return (
        <div className={classes.root} onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
            {avatar && 
                <Avatar className={isUploading ? classes.uploading : ''} alt={user.name} src={avatar} onClick={viewImage} />
            }
            {!avatar &&
                <Avatar alt={user.name} onClick={handleOnClick}>{initials}</Avatar>
            }
            <input
                accept="image/*"
                className={classes.input}
                id="profile-picture"
                multiple
                type="file"
                ref={ref}
                onChange={handleUpload}
            />
            {hover && avatar &&
                <div className={classes.addPhotoText}>
                    <Button className={classes.replaceButton} color="default" variant="outlined" size="small" onClick={handleOnClick}>
                        Replace profile picture
                    </Button>
                    &nbsp;&nbsp;
                    <Tooltip title="Delete profile picture">
                        <DeleteOutlineOutlinedIcon className={classes.deleteIcon} onClick={handleDelete} />
                    </Tooltip>
                </div>
            }
            {!avatar &&
                <div className={classes.addPhotoText}>
                    <Button color="default" size="small" onClick={handleOnClick}>
                        Add a profile picture
                    </Button>
                </div>
            }
            <ConfirmDialog
                title="Confirm delete"
                text="Are you sure you wish to remove this profile picture?"
                agreeText="Delete"
                declineText="Cancel"
                handleClose={handleClose}
                open={open}
                setOpen={setDialogOpen}
            />
        </div>
    )
}

export default UserAvatar;
